import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cangkushenhe",
  "use": "icon-cangkushenhe-usage",
  "viewBox": "0 0 1137 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1137 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cangkushenhe\"><path d=\"M113.800533 455.111111h-53.646222a60.131556 60.131556 0 0 1-36.067555-108.259555L496.833422 24.007111a120.263111 120.263111 0 0 1 144.156445 0l472.746666 322.844445A60.131556 60.131556 0 0 1 1077.668978 455.111111H1024.022756v455.111111a113.777778 113.777778 0 0 1-113.777778 113.777778H227.578311a113.777778 113.777778 0 0 1-113.777778-113.777778V455.111111z m528.668445 185.059556l36.295111-161.564445a112.64 112.64 0 1 0-219.704889 0l36.352 161.564445-142.222222-14.791111A62.293333 62.293333 0 0 0 284.4672 687.388444v12.174223a56.888889 56.888889 0 0 0 56.888889 56.888889h455.111111a56.888889 56.888889 0 0 0 56.888889-56.888889v-12.174223a62.293333 62.293333 0 0 0-68.721778-62.008888l-142.222222 14.791111zM312.854756 796.444444a28.444444 28.444444 0 0 0 0 56.832h512.113777a28.444444 28.444444 0 0 0 0-56.832H312.854756z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cangkushenhe.svg
// module id = Ds93
// module chunks = 36